import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import languageActions from '../behavior/language/actions';

export default function useLanguage(axiosConfig, i18nObj) {
	const dispatch = useDispatch();
	const defaultLanguage = useSelector(
		state => state && state.language && state.language.defaultLanguage
	);
	const [lang, setLang] = useState(defaultLanguage);

	useEffect(() => {
		dispatch(languageActions.getDefaultLanguage(axiosConfig));
	}, []);

	useEffect(() => {
		if (defaultLanguage) {
			i18nObj.changeLanguage(defaultLanguage);
		}
	}, [defaultLanguage]);

	const triggerLanguageChange = newLanguage => {
		i18nObj.changeLanguage(newLanguage);
	};

	i18nObj.on('languageChanged', newLanguage => {
		setLang(newLanguage);
	});

	return [lang, triggerLanguageChange];
}
